import { AlertOptions } from '@ionic/core';

export abstract class NgPreferenceService {
    abstract init(): Promise<any>;
    abstract askForPermission(options: AlertOptions): Promise<void>;
    abstract keys(): Promise<string[]>;
    abstract get<T>(key: string): Promise<T>;
    abstract set(key: string, value: any): Promise<void>;
}
